/**
===================================================
Module: frontend.src.components.visualizer.KeyframePanel.tsx
Description: Keyframe panel component for VSLAM visualizer
Owner: Kawada Technosystem Co Ltd
All Rights Reserved
This script is proprietary and confidential.
Unauthorized copying, distribution, or modification of this
file, via any medium, is strictly prohibited.
===================================================
*/
import React from "react";
import KeyframeViewer from "./KeyframeViewer";
import KeyframeCarousel from "./KeyframeCarousel";
import KeyframeSlider from "./KeyframeSlider";

const KeyframePanel: React.FC = () => {
  return (
    <div className="keyframe-panel">
      <h3 className="keyframe-panel-title">キーフレーム表示</h3>

      <KeyframeViewer />

      <KeyframeCarousel />

      <KeyframeSlider />
    </div>
  );
};

export default KeyframePanel;
